module.exports = __webpack_public_path__ + "static/media/helicopter.72353e52.svg";